import { Injectable } from "@angular/core";
import { retry } from "rxjs/operators";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class SemDynamicsService {
  private formOneValidSubject = new BehaviorSubject<boolean>(false);
  formOneValidSubject$ = this.formOneValidSubject.asObservable();
  private formTwoValidSubject = new BehaviorSubject<boolean>(false);
  formTwoValidSubject$ = this.formTwoValidSubject.asObservable();
  private formThreeValidSubject = new BehaviorSubject<boolean>(false);
  formThreeValidSubject$ = this.formThreeValidSubject.asObservable();
  private formFourValidSubject = new BehaviorSubject<boolean>(false);
  formFourValidSubject$ = this.formFourValidSubject.asObservable();
  private formFiveValidSubject = new BehaviorSubject<boolean>(false);
  formFiveValidSubject$ = this.formFiveValidSubject.asObservable();
  private sectionOneSubject = new BehaviorSubject<any>(null);
  sectionOneSubject$ = this.sectionOneSubject.asObservable();
  private sectionTwoSubject = new BehaviorSubject<any>(null);
  sectionTwoSubject$ = this.sectionTwoSubject.asObservable();
  private sectionThreeSubject = new BehaviorSubject<any>(null);
  sectionThreeSubject$ = this.sectionThreeSubject.asObservable();
  private sectionFourSubject = new BehaviorSubject<any>(null);
  sectionFourSubject$ = this.sectionFourSubject.asObservable();
  private sectionFiveSubject = new BehaviorSubject<any>(null);
  sectionFiveSubject$ = this.sectionFiveSubject.asObservable();
  private allSectionsSubject = new BehaviorSubject<any[]>([]);
  allSectionsSubject$ = this.allSectionsSubject.asObservable();
  constructor(private http: HttpClient) {}

  getAllSections() {
    return this.http.get(`${environment.apiUrl}/cms-admin/sem-pages/section/`);
  }

  setFormOneValid(value: boolean) {
    this.formOneValidSubject.next(value);
  }

  setFormTwoValid(value: boolean) {
    this.formTwoValidSubject.next(value);
  }
  setFormThreeValid(value: boolean) {
    this.formThreeValidSubject.next(value);
  }
  setFormFourValid(value: boolean) {
    this.formFourValidSubject.next(value);
  }
  setFormFiveValid(value: boolean) {
    this.formFiveValidSubject.next(value);
  }

  setSectionOneValue(value: any) {
    this.sectionOneSubject.next(value);
  }

  setSectionTwoValue(value: any) {
    this.sectionTwoSubject.next(value);
  }

  setSectionThreeValue(value: any) {
    this.sectionThreeSubject.next(value);
  }

  setSectionFourValue(value: any) {
    this.sectionFourSubject.next(value);
  }

  setSectionFiveValue(value: any) {
    this.sectionFiveSubject.next(value);
  }

  setSectionsListValue(value: any) {
    this.allSectionsSubject.next(value);
  }

  getAllSemPages() {
    return this.http.get(
      `${environment.apiUrl}/cms-admin/sem-pages/sempages/ `
    );
  }

  deleteSem(data: any) {
    return this.http.post(
      `${environment.apiUrl}/cms-admin/sem-pages/sempages/delete-sem/`,
      data
    );
  }

  getSpecificSemData(id: any) {
    return this.http.get(
      `${environment.apiUrl}/cms-admin/sem-pages/sem-page-create/?sem_pages_id=${id}`
    );
  }

  deleteSubSection(data: any) {
    return this.http.post(
      `${environment.apiUrl}/cms-admin/sem-pages/subsection-delete/`,
      data
    );
  }

  submitAllSectionsData(data: any) {
    return this.http.post(
      `${environment.apiUrl}/cms-admin/sem-pages/sem-page-create/`,
      data
    );
  }

  getSectionOrders() {
    return this.http.get(`${environment.apiUrl}/`);
  }

  checkUrlParam(value: any) {
    return this.http.post(
      `${environment.apiUrl}/cms-admin/sem-pages/sempages/validate-url/`,
      value
    );
  }

  getSectionOrder(id: string) {
    return this.http.get(
      `${environment.apiUrl}/cms-admin/sem-pages/section-postion/?sem_pages_id=${id} `
    );
  }

  sbumitSectionOrder(value: any[]) {
    return this.http.put(
      `${environment.apiUrl}/cms-admin/sem-pages/section-postion/`,
      value
    );
  }
}
